<template>
  <WithBackdrop
    :class="[$style.config, $style.wrap]"
    :backdrop="data?.fields?.backdrop"
  >
    <div :class="$style.container">
      <header>
        <div
          v-if="data?.fields?.media?.fields?.file?.url"
          :class="$style.mediaImage"
        >
          <BasePicture
            :src="data?.fields?.media?.fields?.file?.url + '?q=70&w=250'"
            :alt="data?.fields?.media?.fields?.title || ''"
          />
        </div>

        <BaseHeading size="h2" as="h3">
          {{ data?.fields?.header }}
        </BaseHeading>
        <BaseHeading size="h3">
          {{ data?.fields?.subheader }}
        </BaseHeading>
      </header>
      <MarkedParser class="u-type-p1" :md="data?.fields?.copy" />
      <div v-if="data?.fields?.ctas?.filter(instanceOfCallToAction).length">
        <CallToAction
          v-for="c in data?.fields?.ctas?.filter(instanceOfCallToAction)"
          :key="c.sys.id"
          :data-ctf-id="c.sys.id"
          :cta="c"
        />
      </div>
    </div>
  </WithBackdrop>
</template>

<script setup lang="ts">
import type { TypeContentBlockWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeContentBlockWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.config {
  --wrap-color: #fff;
  --wrap-padding--base: 40px 20px;
  --wrap-padding--md: 60px 60px;
  --wrap-padding: var(--wrap-padding--base);

  --container-max-width--base: 520px;
  --container-max-width--md: 900px;
  --container-max-width: var(--container-max-width--base);

  --container-gap--base: 17px;
  --container-gap--md: 17px;
  --container-gap: var(--container-gap--base);

  --container-grid-template-columns--base: 1fr;
  --container-grid-template-columns--md: 1fr;
  --container-grid-template-columns: var(
    --container-grid-template-columns--base
  );

  --mediaImage-max-width: 520px;

  @include media('md') {
    --wrap-padding: var(--wrap-padding--md);
    --container-max-width: var(--container-max-width--md);
    --container-gap: var(--container-gap--md);
    --container-grid-template-columns: var(
      --container-grid-template-columns--md
    );
  }
}

.wrap {
  padding: var(--wrap-padding);
  color: var(--wrap-color);
}

.container {
  display: grid;
  grid-template-columns: var(--container-grid-template-columns);
  gap: var(--container-gap);
  align-items: center;

  max-width: var(--container-max-width);
  margin: 0 auto;
}

.content {
  display: grid;
  gap: 18px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--roboto-condensed);
  }

  h1,
  h2 {
    @include fluid-type(26px, 42px);
  }
}

.copy {
  @include fluid-type(16px, 19px);
}

.mediaImage {
  max-width: var(--mediaImage-max-width);
}
.img {
  max-width: 100%;
  object-fit: contain;
}
</style>
